import { render, staticRenderFns } from "./UserImpersonator.vue?vue&type=template&id=0bb00912&scoped=true"
import script from "./UserImpersonator.vue?vue&type=script&lang=ts"
export * from "./UserImpersonator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb00912",
  null
  
)

export default component.exports